import React, { useState } from "react";
import FooterIntegration from "./FooterIntegration";
import FooterProduct from "./FooterProduct";
import { NavLink } from "react-router-dom";

import "../../../assets/fonts/social-icons/style.css";
import {
  StyledFooterAuthor,
  StyledFooterContainer,
  StyledFooterDocuments,
  StyledFooterLogo,
  StyledFooterWrapper,
  StyledSocialWrapper
} from "./styledFooter";
import CookiesMessage from "../../cookies/CookiesMessage";
import Cookies from "js-cookie";

const Footer = () => {
  const initialCookies = {
    strictlyNecessary: true,
    functional: false,
    performance: false,
    targeting: false,
    agree: false
  };

  const [cookie, setCookie] = useState(initialCookies);

  const currentYear = (new Date().getFullYear());

  return (
    <StyledFooterWrapper>
      {!Cookies.get("useCookiesConsent") && <CookiesMessage
        cookie={cookie}
        setCookie={setCookie}
      />}
      <StyledFooterContainer>
        <StyledFooterLogo>
          Text me chat
        </StyledFooterLogo>
        <StyledSocialWrapper>
          {/*<ul>
            <li>
              <a href="#" target="_blank">
                <span className="social-icon-instagram"/>
              </a>
            </li>
            <li>
              <a href="#" target="_blank">
                <span className="social-icon-telegram"/>
              </a>
            </li>
            <li>
              <a href="#" target="_blank">
                <span className="social-icon-facebook"/>
              </a>
            </li>
          </ul>*/}
          {/*<p>
            10030, Zhytomyr, Zhytomyrska oblast Ukraine
          </p>*/}
          <p>
            Is your best multi-channel online consultant on the site!
          </p>
        </StyledSocialWrapper>
        <nav className="footer-nav">
          <FooterProduct />
          <FooterIntegration />
          {/*<FooterContacts />*/}
        </nav>
        <div className="footer-doc">
          <StyledFooterAuthor>
            © {currentYear}. All right reserved
          </StyledFooterAuthor>
          <StyledFooterDocuments>
            <li>
              <NavLink
                to="/user-agreement"
                target="_blank"
              >
                Terms & Conditions
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/privacy-policy"
                target="_blank"
              >
                Privacy Policy
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/cookies-policy"
                target="_blank"
              >
                Cookies Policy
              </NavLink>
            </li>
          </StyledFooterDocuments>
        </div>
      </StyledFooterContainer>
    </StyledFooterWrapper>
  );
};

export default Footer;